import { getParsedErrorMessage } from 'redux/axios';
import { ChecklistMetricStatus } from '../../handoff-checklist-v2/handoff-checklist-v2.types';
import { VoiceAirMetricDefinition, MetricEvalContext } from '../voice-air-metrics.types';
import { getVoiceAiTasksReviewedCountQueryOptions } from '../voice-air-handoff.queries';
import { WEAVE_APP_URL } from 'apis/sso/sso-url-config';

export const MIN_REVIEWED_AI_TASKS = 3;

// Warning-only: never returns BLOCKED, since this does not block handoff in V1.
export const evaluateVoiceAiTasksReviewed = async (ctx: MetricEvalContext) => {
  try {
    const response = await ctx.queryClient.fetchQuery(
      getVoiceAiTasksReviewedCountQueryOptions(ctx.locationId)
    );
    const count = response?.reviewed ?? 0;

    if (count >= MIN_REVIEWED_AI_TASKS) {
      return {
        status: ChecklistMetricStatus.PASSED,
        reason: 'voice_ai_tasks_reviewed' as const,
        message: `${count} voice AI tasks were reviewed in the last 7 days.`,
      };
    }
    return {
      status: ChecklistMetricStatus.WARNING,
      reason: 'voice_ai_tasks_pending' as const,
      message: `${count} voice AI tasks were reviewed in the last 7 days. Recent AI tasks may need review before handoff.`,
    };
  } catch (err) {
    return {
      status: ChecklistMetricStatus.WARNING,
      reason: 'api_request_failed' as const,
      message: getParsedErrorMessage(err) || 'Failed to verify reviewed voice AI tasks.',
    };
  }
};

export const voiceAiTasksReviewedMetric: VoiceAirMetricDefinition = {
  id: 'voice_ai_tasks_reviewed',
  name: 'Voice AI Tasks Reviewed',
  isRequired: false,
  criteria: [
    {
      description: 'At least 3 voice AI tasks have been reviewed in the last 7 days.',
      evaluate: evaluateVoiceAiTasksReviewed,
      whereToFix: {
        label: 'Task center in Weave',
        url: WEAVE_APP_URL,
      },
    },
  ],
};
